import React from 'react';
import { KFLLayout } from '@kamstrup/kamstrup-frontend-library';
import TopHeader from '../layout/topheader';
import Menu from '../layout/menu';
import Sidebar from '../layout/sidebar';

const NotFoundPage: React.FC = () => {
  return (
    <KFLLayout
      topbar={<TopHeader />}
      content={<div>This is not a valid page.</div>}
      menu={<Menu title="Not Found Page" />}
      sidebar={<Sidebar selectedGroup="NotFound" />}
    />
  );
};

export default NotFoundPage;
